const isMotionValue = (value) => value === undefined ? false : !!value.getVelocity;

export { isMotionValue };
